// @flow
export const getFromLocal = (name: string) => {
  const localData = typeof localStorage !== 'undefined' ? localStorage.getItem(name) : null;
  if (!localData) return;
  try {
    const data = JSON.parse(localData);
    if (data.timestamp && data.content) {
      const seconds = Math.floor((new Date() - new Date(data.timestamp)) / 1000);
      if (seconds > 180) return;
      return JSON.parse(data.content);
    }
  } catch (err) {
    console.log(err);
  }
};
